/// <reference path="../../typings/index.d.ts" />

module monitoringApp.controllers {
    class ExternalReportController {
       private error = 'All';
       private fromDate;
       private toDate;
       constructor(){
           this.toDate = new Date();
           this.fromDate = new Date();
           this.fromDate.setDate(this.toDate.getDate() - 1);
           
       }

       private getDate(dateStr:string){
           return new Date(dateStr);
       }

       private getDateStr(date:Date){
           //@ts-ignore
           return moment(date).format('YYYY-MM-DD');
       }
    }

    angular.module("ultimateMonitoringApp").controller("externalReportController", ExternalReportController);
}
